@if (rate) {
  <a class="rate-link" [href]="getRateUrl()" target="_blank">
    <i class="pi pi-external-link"></i>
  </a>
}
<p-autocomplete
  [(ngModel)]="rate"
  [suggestions]="rateList"
  (completeMethod)="search($event.query)"
  (onSelect)="onRateChange($event.value)"
  (onClear)="onRateChange(null)"
  placeholder="None"
  optionLabel="rateAndCarrierName"
  [multiple]="false"
  [dropdown]="true"
  [showEmptyMessage]="true"
  [minQueryLength]="2"
>
  <ng-template #empty>
    <app-autocomplete-empty-message
      [loading]="loading()"
      text="Rate not found"
    ></app-autocomplete-empty-message>
  </ng-template>
</p-autocomplete>
